module.exports = __webpack_public_path__ + "static/media/checked.7ccec405.svg";